import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";

/**
 * Fetch all user rate mappings
 */
export const fetchUserRateMappings = createAsyncThunk(
  "userRateMapping/fetchData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await get(API_ENDPOINTS.TAB_MAPPING.GET_USER_RATE_MAPPING);
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch user rate mappings"));
    }
  }
);
